import { Logger } from 'services';

export const trackingGroupLeaveRequest = (operation: any) => {
  Logger.log('trackGroupLeaveRequest');
};

export const trackingGroupLeaveResponse = (operation: any) => {
  Logger.log('trackingGroupLeaveResponse');
};
